<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Cadastrar captcha</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form v-on:submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label="Nome do captcha:" :state="captcha.stateFotos">
                          <b-input-group class="mb-6">
                            <b-input-group-prepend>
                              <b-input-group-text><i class="icon-arrow-right"></i></b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input type="text"
                                          class="form-control"
                                          placeholder="Nome do captcha"
                                          v-model="captcha.nome"
                                          :state="captcha.nomeState"
                                          autocomplete="captcha"
                                          autofocus/>
                            <b-form-invalid-feedback id="input1LiveFeedback1">Nome do captcha é obrigatório.</b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                   <b-col cols="6">
                       <label>Arquivo do vídeo:</label>
                       <span class="icon-info" v-b-popover.hover.top="'Arquivo de vídeo: tipo .mp4 e no máximo 10mb'" title="Informação"></span>
                       <b-form-group label-for="nome-input" :state="captcha.videoState" invalid-feedback="Vídeo é obrigatório">
                            <b-form-file
                                    v-on:change="uploadVideo"
                                    v-model="captcha.video"
                                    :state="captcha.videoState"
                                    browse-text="Selecione"
                                    placeholder="Selecione o vídeo..."
                            ></b-form-file>
                        </b-form-group>
                   </b-col>
                   <b-col cols="3">
                        <b-form-group label="Status:">
                            <b-form-radio-group id="radio-slots" :options="numStatus" v-model="captcha.status" name="radio-options-slots"/>
                        </b-form-group>
                    </b-col>
                   <b-col cols="3">
                         <label>Respostas:</label>
                         <span class="icon-info" v-b-popover.hover.top="'Imagem das respostas: .jpg no máximo 100k'" title="Informação"></span>
                        <b-form-group :state="captcha.respostasState">
                            <b-form-radio-group id="radio-slots-respostas" v-model="captcha.respostas" :state="captcha.respostasState" :options="numRespostas" name="radio-options-slots-respostas"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                  <b-row>
                        <b-col cols="12" md="12">
                            <b-alert dismissible v-if="validacaoImagens" show variant="danger">É necessário realizar o upload de uma foto para cada resposta.</b-alert>
                        </b-col>
                    </b-row>
                <span v-if="captcha.respostas == 3">
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group :state="captcha.form3.resposta1State" invalid-feedback="Campo é obrigatório">
                                <label>Resposta 1</label>
                                <b-input-group class="mb-4" invalid-feedback="Campo é obrigatório">
                                    <b-form-input type="text" class="form-control" :state="captcha.form3.resposta1State" v-model="captcha.form3.resposta1" autocomplete="captcha"/>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar1"><i class="fa fa-upload"></i> Upload</b-button>
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar1"
                                        :upload-url="this.$api1 + 'api/upload/' + 1 + '/3'" />&nbsp;
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form3.corretaState" v-model="captcha.form3.correta" value="1">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form3.foto1">
                                    <img class="preview" :src="captcha.form3.foto1">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(1, 3)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group :state="captcha.form3.resposta2State" invalid-feedback="Campo é obrigatório">
                                <label>Resposta 2</label>
                                <b-input-group class="mb-4" :state="captcha.form3.resposta2State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form3.resposta2State" v-model="captcha.form3.resposta2" autocomplete="captcha" invalid-feedback="Campo é obrigatório" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar2"><i class="fa fa-upload"></i> Upload</b-button>
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar2"
                                        :upload-url="this.$api1 + 'api/upload/' + 2 + '/3'" />&nbsp;
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form3.corretaState" v-model="captcha.form3.correta" value="2">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form3.foto2">
                                    <img class="preview" :src="captcha.form3.foto2">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(2, 3)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group :state="captcha.form3.resposta3State" invalid-feedback="Campo é obrigatório">
                                <label>Resposta 3</label>
                                <b-input-group class="mb-4" :state="captcha.form3.resposta3State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form3.resposta3State" v-model="captcha.form3.resposta3" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar3"><i class="fa fa-upload"></i> Upload</b-button>
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar3"
                                        :upload-url="this.$api1 + 'api/upload/' + 3 + '/3'" />&nbsp;
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form3.corretaState" v-model="captcha.form3.correta" value="3">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form3.foto3">
                                    <img class="preview" :src="captcha.form3.foto3">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(3, 3)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                </span>
                <span v-if="captcha.respostas == 6">
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta1State">
                                <label>Resposta 1</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta1State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta1State" v-model="captcha.form6.resposta1" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar4"><i class="fa fa-upload"></i> Upload</b-button>
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar4"
                                        :upload-url="this.$api1 + 'api/upload/' + 1 + '/6'" />&nbsp;
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="1">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto1">
                                    <img class="preview" :src="captcha.form6.foto1">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(1, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta2State">
                                <label>Resposta 2</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta2State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta2State" v-model="captcha.form6.resposta2" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar5"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar5"
                                        :upload-url="this.$api1 + 'api/upload/' + 2 + '/6'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="2">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto2">
                                    <img class="preview" :src="captcha.form6.foto2">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(2, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta3State">
                                <label>Resposta 3</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta3State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta3State" v-model="captcha.form6.resposta3" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar6"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar6"
                                        :upload-url="this.$api1 + 'api/upload/' + 3 + '/6'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="3">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto3">
                                    <img class="preview" :src="captcha.form6.foto3">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(3, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta4State">
                                <label>Resposta 4</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta4State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta4State" v-model="captcha.form6.resposta4" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar7"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar7"
                                        :upload-url="this.$api1 + 'api/upload/' + 4 + '/6'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="4">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto4">
                                    <img class="preview" :src="captcha.form6.foto4">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(4, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta5State">
                                <label>Resposta 5</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta5State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta5State" v-model="captcha.form6.resposta5" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar8"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar8"
                                        :upload-url="this.$api1 + 'api/upload/' + 5 + '/6'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="5">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto5">
                                    <img class="preview" :src="captcha.form6.foto5">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(5, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form6.resposta6State">
                                <label>Resposta 6</label>
                                <b-input-group class="mb-4" :state="captcha.form6.resposta6State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form6.resposta6State" v-model="captcha.form6.resposta6" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar9"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar9"
                                        :upload-url="this.$api1 + 'api/upload/' + 6 + '/6'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form6.corretaState" v-model="captcha.form6.correta" value="6">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form6.foto6">
                                    <img class="preview" :src="captcha.form6.foto6">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(6, 6)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                </span>
                <span v-if="captcha.respostas == 9">
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta1State">
                                <label>Resposta 1</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta1State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta1State" v-model="captcha.form9.resposta1" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar10"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar10"
                                        :upload-url="this.$api1 + 'api/upload/' + 1 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="1">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto1">
                                    <img class="preview" :src="captcha.form9.foto1">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(1, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta2State">
                                <label>Resposta 2</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta2State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta2State" v-model="captcha.form9.resposta2" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar11"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar11"
                                        :upload-url="this.$api1 + 'api/upload/' + 2 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="2">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto2">
                                    <img class="preview" :src="captcha.form9.foto2">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(2, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta3State">
                                <label>Resposta 3</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta3State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta3State" v-model="captcha.form9.resposta3" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar12"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar12"
                                        :upload-url="this.$api1 + 'api/upload/' + 3 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="3">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto3">
                                    <img class="preview" :src="captcha.form9.foto3">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(3, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta4State">
                                <label>Resposta 4</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta4State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta4State" v-model="captcha.form9.resposta4" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar13"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar13"
                                        :upload-url="this.$api1 + 'api/upload/' + 4 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" v-model="captcha.form9.correta" :state="captcha.form9.corretaState" value="4">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto4">
                                    <img class="preview" :src="captcha.form9.foto4">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(4, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta5State">
                                <label>Resposta 5</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta5State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta5State" v-model="captcha.form9.resposta5" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar14"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar14"
                                        :upload-url="this.$api1 + 'api/upload/' + 5 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="5">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto5">
                                    <img class="preview" :src="captcha.form9.foto5">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(5, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta6State">
                                <label>Resposta 6</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta6State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta6State" v-model="captcha.form9.resposta6" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar15"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar15"
                                        :upload-url="this.$api1 + 'api/upload/' + 6 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="6">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto6">
                                    <img class="preview" :src="captcha.form9.foto6">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(6, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta7State">
                                <label>Resposta 7</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta7State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta7State" v-model="captcha.form9.resposta7" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar16"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar16"
                                        :upload-url="this.$api1 + 'api/upload/' + 7 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="7">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto7">
                                    <img class="preview" :src="captcha.form9.foto7">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(7, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta8State">
                                <label>Resposta 8</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta8State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta8State" v-model="captcha.form9.resposta8" autocomplete="captcha" />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar17"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar17"
                                        :upload-url="this.$api1 + 'api/upload/' + 8 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="8">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto8">
                                    <img class="preview" :src="captcha.form9.foto8">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(8, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group invalid-feedback="Campo é obrigatório" :state="captcha.form9.resposta9State">
                                <label>Resposta 9</label>
                                <b-input-group class="mb-4" :state="captcha.form9.resposta9State">
                                    <b-form-input type="text" class="form-control" :state="captcha.form9.resposta9State" v-model="captcha.form9.resposta9" autocomplete="captcha"/>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="2">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-button variant="primary" id="pick-avatar18"><i class="fa fa-upload"></i> Upload</b-button>&nbsp;
                                <avatar-cropper
                                        @uploading="handleUploading"
                                        @uploaded="handleUploaded"
                                        @completed="handleCompleted"
                                        @error="handlerError" :labels="{ submit: 'Enviar', cancel: 'Cancelar'}"
                                        trigger="#pick-avatar18"
                                        :upload-url="this.$api1 + 'api/upload/' + 9 + '/9'" />
                            </b-col>
                        </b-col>
                        <b-col cols="12" md="1">
                            <label>&nbsp;</label>
                            <b-col lg="8" class="pb-8">
                                <b-form-radio name="radio-options-slots-respostas-text" :state="captcha.form9.corretaState" v-model="captcha.form9.correta" value="9">Correta</b-form-radio>
                            </b-col>
                        </b-col>
                         <b-col cols="12" md="2">
                            <b-col lg="8" class="pb-8">
                                 <div class="image-preview" v-if="captcha.form9.foto9">
                                    <img class="preview" :src="captcha.form9.foto9">
                                    <br><br>
                                    <b-button size="sm" variant="danger" @click="apagarFoto(9, 9)">Apagar Foto</b-button>
                                 </div>
                            </b-col>
                            <br>
                        </b-col>
                    </b-row>
                </span>
             </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3">
              <b-button v-if="!loading" block variant="primary" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
              <b-button v-else block variant="primary" disabled>
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Cancelar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import AvatarCropper from 'vue-avatar-cropper'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: { AvatarCropper },
  name: 'Cadastro',
  created () {
    if (!this.can('captcha.store')) {
      this.$router.push('/')
    }
  },
  data () {
    return {
      validacaoImagens: false,
      loading: false,
      captcha: {
        nome: '',
        nomeState: null,
        video: null,
        videoState: null,
        status: true,
        respostas: 3,
        respostasState: null,
        form3: {
          resposta1: '',
          resposta1State: null,
          resposta2: '',
          resposta2State: null,
          resposta3: '',
          resposta3State: null,
          foto1: '',
          foto2: '',
          foto3: '',
          correta: null,
          corretaState: null
        },
        form6: {
          resposta1: '',
          resposta1State: null,
          resposta2: '',
          resposta2State: null,
          resposta3: '',
          resposta3State: null,
          resposta4: '',
          resposta4State: null,
          resposta5: '',
          resposta5State: null,
          resposta6: '',
          resposta6State: null,
          foto1: '',
          foto2: '',
          foto3: '',
          foto4: '',
          foto5: '',
          foto6: '',
          correta: null,
          corretaState: null
        },
        form9: {
          resposta1: '',
          resposta1State: null,
          resposta2: '',
          resposta2State: null,
          resposta3: '',
          resposta3State: null,
          resposta4: '',
          resposta4State: null,
          resposta5: '',
          resposta5State: null,
          resposta6: '',
          resposta6State: null,
          resposta7: '',
          resposta7State: null,
          resposta8: '',
          resposta8State: null,
          resposta9: '',
          resposta9State: null,
          foto1: '',
          foto2: '',
          foto3: '',
          foto4: '',
          foto5: '',
          foto6: '',
          foto7: '',
          foto8: '',
          foto9: '',
          correta: null,
          corretaState: null
        }
      },
      numStatus: [
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }
      ],
      numRespostas: [
        { text: '3', value: 3 },
        { text: '6', value: 6 },
        { text: '9', value: 9 }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  watch: {
    'captcha.form3.correta': function () {
      this.captcha.form6.correta = this.captcha.form3.correta
      this.captcha.form9.correta = this.captcha.form3.correta
    },
    'captcha.form6.correta': function () {
      this.captcha.form3.correta = this.captcha.form6.correta
      this.captcha.form9.correta = this.captcha.form6.correta
    },
    'captcha.form9.correta': function () {
      this.captcha.form3.correta = this.captcha.form9.correta
      this.captcha.form6.correta = this.captcha.form9.correta
    },
    'captcha.form3.resposta1': function () {
      this.captcha.form3.resposta1 = this.captcha.form3.resposta1
      this.captcha.form6.resposta1 = this.captcha.form3.resposta1
      this.captcha.form9.resposta1 = this.captcha.form3.resposta1
    },
    'captcha.form3.resposta2': function () {
      this.captcha.form3.resposta2 = this.captcha.form3.resposta2
      this.captcha.form6.resposta2 = this.captcha.form3.resposta2
      this.captcha.form9.resposta2 = this.captcha.form3.resposta2
    },
    'captcha.form3.resposta3': function () {
      this.captcha.form3.resposta3 = this.captcha.form3.resposta3
      this.captcha.form6.resposta3 = this.captcha.form3.resposta3
      this.captcha.form9.resposta3 = this.captcha.form3.resposta3
    },
    'captcha.form6.resposta1': function () {
      this.captcha.form3.resposta1 = this.captcha.form6.resposta1
      this.captcha.form6.resposta1 = this.captcha.form6.resposta1
      this.captcha.form9.resposta1 = this.captcha.form6.resposta1
    },
    'captcha.form6.resposta2': function () {
      this.captcha.form3.resposta2 = this.captcha.form6.resposta2
      this.captcha.form6.resposta2 = this.captcha.form6.resposta2
      this.captcha.form9.resposta2 = this.captcha.form6.resposta2
    },
    'captcha.form6.resposta3': function () {
      this.captcha.form3.resposta3 = this.captcha.form6.resposta3
      this.captcha.form6.resposta3 = this.captcha.form6.resposta3
      this.captcha.form9.resposta3 = this.captcha.form6.resposta3
    },
    'captcha.form6.resposta4': function () {
      this.captcha.form6.resposta4 = this.captcha.form6.resposta4
      this.captcha.form9.resposta4 = this.captcha.form6.resposta4
    },
    'captcha.form6.resposta5': function () {
      this.captcha.form6.resposta5 = this.captcha.form6.resposta5
      this.captcha.form9.resposta5 = this.captcha.form6.resposta5
    },
    'captcha.form6.resposta6': function () {
      this.captcha.form6.resposta6 = this.captcha.form6.resposta6
      this.captcha.form9.resposta6 = this.captcha.form6.resposta6
    },
    'captcha.form9.resposta1': function () {
      this.captcha.form3.resposta1 = this.captcha.form9.resposta1
      this.captcha.form6.resposta1 = this.captcha.form9.resposta1
      this.captcha.form9.resposta1 = this.captcha.form9.resposta1
    },
    'captcha.form9.resposta2': function () {
      this.captcha.form3.resposta2 = this.captcha.form9.resposta2
      this.captcha.form6.resposta2 = this.captcha.form9.resposta2
      this.captcha.form9.resposta2 = this.captcha.form9.resposta2
    },
    'captcha.form9.resposta3': function () {
      this.captcha.form3.resposta3 = this.captcha.form9.resposta3
      this.captcha.form6.resposta3 = this.captcha.form9.resposta3
      this.captcha.form9.resposta3 = this.captcha.form9.resposta3
    },
    'captcha.form9.resposta4': function () {
      this.captcha.form6.resposta4 = this.captcha.form9.resposta4
      this.captcha.form9.resposta4 = this.captcha.form9.resposta4
    },
    'captcha.form9.resposta5': function () {
      this.captcha.form6.resposta5 = this.captcha.form9.resposta5
      this.captcha.form9.resposta5 = this.captcha.form9.resposta5
    },
    'captcha.form9.resposta6': function () {
      this.captcha.form6.resposta6 = this.captcha.form9.resposta6
      this.captcha.form9.resposta6 = this.captcha.form9.resposta6
    },
    'captcha.form9.resposta7': function () {
      this.captcha.form9.resposta7 = this.captcha.form9.resposta7
    },
    'captcha.form9.resposta8': function () {
      this.captcha.form9.resposta8 = this.captcha.form9.resposta8
    },
    'captcha.form9.resposta9': function () {
      this.captcha.form9.resposta9 = this.captcha.form9.resposta9
    },
    'captcha.form3.foto1': function () {
      this.captcha.form3.foto1 = this.captcha.form3.foto1
      this.captcha.form6.foto1 = this.captcha.form3.foto1
      this.captcha.form9.foto1 = this.captcha.form3.foto1
    },
    'captcha.form3.foto2': function () {
      this.captcha.form3.foto2 = this.captcha.form3.foto2
      this.captcha.form6.foto2 = this.captcha.form3.foto2
      this.captcha.form9.foto2 = this.captcha.form3.foto2
    },
    'captcha.form3.foto3': function () {
      this.captcha.form3.foto3 = this.captcha.form3.foto3
      this.captcha.form6.foto3 = this.captcha.form3.foto3
      this.captcha.form9.foto3 = this.captcha.form3.foto3
    },
    'captcha.form6.foto1': function () {
      this.captcha.form3.foto1 = this.captcha.form6.foto1
      this.captcha.form6.foto1 = this.captcha.form6.foto1
      this.captcha.form9.foto1 = this.captcha.form6.foto1
    },
    'captcha.form6.foto2': function () {
      this.captcha.form3.foto2 = this.captcha.form6.foto2
      this.captcha.form6.foto2 = this.captcha.form6.foto2
      this.captcha.form9.foto2 = this.captcha.form6.foto2
    },
    'captcha.form6.foto3': function () {
      this.captcha.form3.foto3 = this.captcha.form6.foto3
      this.captcha.form6.foto3 = this.captcha.form6.foto3
      this.captcha.form9.foto3 = this.captcha.form6.foto3
    },
    'captcha.form6.foto4': function () {
      this.captcha.form6.foto4 = this.captcha.form6.foto4
      this.captcha.form9.foto4 = this.captcha.form6.foto4
    },
    'captcha.form6.foto5': function () {
      this.captcha.form6.foto5 = this.captcha.form6.foto5
      this.captcha.form9.foto5 = this.captcha.form6.foto5
    },
    'captcha.form6.foto6': function () {
      this.captcha.form6.foto6 = this.captcha.form6.foto6
      this.captcha.form9.foto6 = this.captcha.form6.foto6
    },
    'captcha.form9.foto1': function () {
      this.captcha.form3.foto1 = this.captcha.form9.foto1
      this.captcha.form6.foto1 = this.captcha.form9.foto1
      this.captcha.form9.foto1 = this.captcha.form9.foto1
    },
    'captcha.form9.foto2': function () {
      this.captcha.form3.foto2 = this.captcha.form9.foto2
      this.captcha.form6.foto2 = this.captcha.form9.foto2
      this.captcha.form9.foto2 = this.captcha.form9.foto2
    },
    'captcha.form9.foto3': function () {
      this.captcha.form3.foto3 = this.captcha.form9.foto3
      this.captcha.form6.foto3 = this.captcha.form9.foto3
      this.captcha.form9.foto3 = this.captcha.form9.foto3
    },
    'captcha.form9.foto4': function () {
      this.captcha.form6.foto4 = this.captcha.form9.foto4
      this.captcha.form9.foto4 = this.captcha.form9.foto4
    },
    'captcha.form9.foto5': function () {
      this.captcha.form6.foto5 = this.captcha.form9.foto5
      this.captcha.form9.foto5 = this.captcha.form9.foto5
    },
    'captcha.form9.foto6': function () {
      this.captcha.form6.foto6 = this.captcha.form9.foto6
      this.captcha.form9.foto6 = this.captcha.form9.foto6
    },
    'captcha.form9.foto7': function () {
      this.captcha.form9.foto7 = this.captcha.form9.foto7
    },
    'captcha.form9.foto8': function () {
      this.captcha.form9.foto8 = this.captcha.form9.foto8
    },
    'captcha.form9.foto9': function () {
      this.captcha.form9.foto9 = this.captcha.form9.foto9
    }
  },
  methods: {
    onSubmit () {
      if (this.validar()) {
        let respostas

        if (this.captcha.respostas === 3) {
          respostas = [
            {
              foto: this.captcha.form3.foto1,
              texto: this.captcha.form3.resposta1,
              correta: this.captcha.form3.correta === '1'
            },
            {
              foto: this.captcha.form3.foto2,
              texto: this.captcha.form3.resposta2,
              correta: this.captcha.form3.correta === '2'
            },
            {
              foto: this.captcha.form3.foto3,
              texto: this.captcha.form3.resposta3,
              correta: this.captcha.form3.correta === '3'
            }
          ]
        }

        if (this.captcha.respostas === 6) {
          respostas = [
            {
              foto: this.captcha.form6.foto1,
              texto: this.captcha.form6.resposta1,
              correta: this.captcha.form6.correta === '1'
            },
            {
              foto: this.captcha.form6.foto2,
              texto: this.captcha.form6.resposta2,
              correta: this.captcha.form6.correta === '2'
            },
            {
              foto: this.captcha.form6.foto3,
              texto: this.captcha.form6.resposta3,
              correta: this.captcha.form6.correta === '3'
            },
            {
              foto: this.captcha.form6.foto4,
              texto: this.captcha.form6.resposta4,
              correta: this.captcha.form6.correta === '4'
            },
            {
              foto: this.captcha.form6.foto5,
              texto: this.captcha.form6.resposta5,
              correta: this.captcha.form6.correta === '5'
            },
            {
              foto: this.captcha.form6.foto6,
              texto: this.captcha.form6.resposta6,
              correta: this.captcha.form6.correta === '6'
            }
          ]
        }

        if (this.captcha.respostas === 9) {
          respostas = [
            {
              foto: this.captcha.form9.foto1,
              texto: this.captcha.form9.resposta1,
              correta: this.captcha.form9.correta === '1'
            },
            {
              foto: this.captcha.form9.foto2,
              texto: this.captcha.form9.resposta2,
              correta: this.captcha.form9.correta === '2'
            },
            {
              foto: this.captcha.form9.foto3,
              texto: this.captcha.form9.resposta3,
              correta: this.captcha.form9.correta === '3'
            },
            {
              foto: this.captcha.form9.foto4,
              texto: this.captcha.form9.resposta4,
              correta: this.captcha.form9.correta === '4'
            },
            {
              foto: this.captcha.form9.foto5,
              texto: this.captcha.form9.resposta5,
              correta: this.captcha.form9.correta === '5'
            },
            {
              foto: this.captcha.form9.foto6,
              texto: this.captcha.form9.resposta6,
              correta: this.captcha.form9.correta === '6'
            },
            {
              foto: this.captcha.form9.foto7,
              texto: this.captcha.form9.resposta7,
              correta: this.captcha.form9.correta === '7'
            },
            {
              foto: this.captcha.form9.foto8,
              texto: this.captcha.form9.resposta8,
              correta: this.captcha.form9.correta === '8'
            },
            {
              foto: this.captcha.form9.foto9,
              texto: this.captcha.form9.resposta9,
              correta: this.captcha.form9.correta === '9'
            }
          ]
        }

        let data = {
          nome: this.captcha.nome,
          video: this.captcha.video,
          ativo: this.captcha.status,
          numero_alternativas: this.captcha.respostas,
          respostas: respostas
        }

        this.loading = true

        Vue.http.post('api/captcha', data).then(response => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.loading = false
            this.$router.push({path: '/captchas'})
          } else {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(response.body.msg, 'Alerta', 5000)
            this.loading = false
          }
        }).catch(e => {
          let response = e.body.data
          if (response) {
            for (let erro of response) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Erro!', 5000)
            }
          }
          this.loading = false
        })
      }
    },
    uploadVideo (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.captcha.video = evento.target.result
      }

      reader.readAsDataURL(arquivo[0])
    },
    handleUploading (form, xhr) {
      this.message = 'Enviando...'
    },
    handleUploaded (response) {
      if (!response.success) {
        if (response.msg) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(response.msg, 'Alerta!', 7000)
        }

        if (response.data) {
          if (response.data.file) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
            miniToastr.error(response.data.file[0], 'Alerta!', 7000)
          }
        }
      }

      if (response.status === 'success') {
        if (parseInt(response.formulario) === 3) {
          if (parseInt(response.alternativa) === 1) {
            this.captcha.form3.foto1 = response.url
          }

          if (parseInt(response.alternativa) === 2) {
            this.captcha.form3.foto2 = response.url
          }

          if (parseInt(response.alternativa) === 3) {
            this.captcha.form3.foto3 = response.url
          }
        } else if (parseInt(response.formulario) === 6) {
          if (parseInt(response.alternativa) === 1) {
            this.captcha.form6.foto1 = response.url
          }

          if (parseInt(response.alternativa) === 2) {
            this.captcha.form6.foto2 = response.url
          }

          if (parseInt(response.alternativa) === 3) {
            this.captcha.form6.foto3 = response.url
          }

          if (parseInt(response.alternativa) === 4) {
            this.captcha.form6.foto4 = response.url
          }

          if (parseInt(response.alternativa) === 5) {
            this.captcha.form6.foto5 = response.url
          }

          if (parseInt(response.alternativa) === 6) {
            this.captcha.form6.foto6 = response.url
          }
        } else if (parseInt(response.formulario) === 9) {
          if (parseInt(response.alternativa) === 1) {
            this.captcha.form9.foto1 = response.url
          }

          if (parseInt(response.alternativa) === 2) {
            this.captcha.form9.foto2 = response.url
          }

          if (parseInt(response.alternativa) === 3) {
            this.captcha.form9.foto3 = response.url
          }

          if (parseInt(response.alternativa) === 4) {
            this.captcha.form9.foto4 = response.url
          }

          if (parseInt(response.alternativa) === 5) {
            this.captcha.form9.foto5 = response.url
          }

          if (parseInt(response.alternativa) === 6) {
            this.captcha.form9.foto6 = response.url
          }

          if (parseInt(response.alternativa) === 7) {
            this.captcha.form9.foto7 = response.url
          }

          if (parseInt(response.alternativa) === 8) {
            this.captcha.form9.foto8 = response.url
          }

          if (parseInt(response.alternativa) === 9) {
            this.captcha.form9.foto9 = response.url
          }
        }
      }
    },
    handleCompleted (response, form, xhr) {
      this.message = 'Imagem atualizada.'
    },
    handlerError (message, type, xhr) {
      miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
      miniToastr.error('Ops... O tamanho máximo permitido para as fotos é de 100k', 'Alerta!', 7000)
    },
    apagarFoto (foto, form) {
      if (form === 3) {
        if (foto === 1) {
          this.captcha.form3.foto1 = ''
        }
        if (foto === 2) {
          this.captcha.form3.foto2 = ''
        }
        if (foto === 3) {
          this.captcha.form3.foto3 = ''
        }
      }
      if (form === 6) {
        if (foto === 1) {
          this.captcha.form6.foto1 = ''
        }
        if (foto === 2) {
          this.captcha.form6.foto2 = ''
        }
        if (foto === 3) {
          this.captcha.form6.foto3 = ''
        }
        if (foto === 4) {
          this.captcha.form6.foto4 = ''
        }
        if (foto === 5) {
          this.captcha.form6.foto5 = ''
        }
        if (foto === 6) {
          this.captcha.form6.foto6 = ''
        }
      }
      if (form === 9) {
        if (foto === 1) {
          this.captcha.form9.foto1 = ''
        }
        if (foto === 2) {
          this.captcha.form9.foto2 = ''
        }
        if (foto === 3) {
          this.captcha.form9.foto3 = ''
        }
        if (foto === 4) {
          this.captcha.form9.foto4 = ''
        }
        if (foto === 5) {
          this.captcha.form9.foto5 = ''
        }
        if (foto === 6) {
          this.captcha.form9.foto6 = ''
        }
        if (foto === 7) {
          this.captcha.form9.foto7 = ''
        }
        if (foto === 8) {
          this.captcha.form9.foto8 = ''
        }
        if (foto === 9) {
          this.captcha.form9.foto9 = ''
        }
      }
    },
    validar () {
      let result = true

      if (!this.captcha.nome) {
        this.captcha.nomeState = false
        result = false
      } else {
        this.captcha.nomeState = true
      }

      if (!this.captcha.video) {
        this.captcha.videoState = false
        result = false
      } else {
        this.captcha.videoState = true
      }

      let count = 0

      if (this.captcha.respostas === 3) {
        if (!this.captcha.form3.resposta1) {
          this.captcha.form3.resposta1State = false
          result = false
        } else {
          this.captcha.form3.resposta1State = true
        }

        if (!this.captcha.form3.resposta2) {
          this.captcha.form3.resposta2State = false
          result = false
        } else {
          this.captcha.form3.resposta2State = true
        }

        if (!this.captcha.form3.resposta3) {
          this.captcha.form3.resposta3State = false
          result = false
        } else {
          this.captcha.form3.resposta3State = true
        }

        if (!this.captcha.form3.foto1) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form3.foto2) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form3.foto3) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form3.correta) {
          this.captcha.form3.corretaState = false
          result = false
        } else {
          this.captcha.form3.corretaState = true
        }
      } else if (this.captcha.respostas === 6) {
        if (!this.captcha.form6.resposta1) {
          this.captcha.form6.resposta1State = false
          result = false
        } else {
          this.captcha.form6.resposta1State = true
        }

        if (!this.captcha.form6.resposta2) {
          this.captcha.form6.resposta2State = false
          result = false
        } else {
          this.captcha.form6.resposta2State = true
        }

        if (!this.captcha.form6.resposta3) {
          this.captcha.form6.resposta3State = false
          result = false
        } else {
          this.captcha.form6.resposta3State = true
        }

        if (!this.captcha.form6.resposta4) {
          this.captcha.form6.resposta4State = false
          result = false
        } else {
          this.captcha.form6.resposta4State = true
        }

        if (!this.captcha.form6.resposta5) {
          this.captcha.form6.resposta5State = false
          result = false
        } else {
          this.captcha.form6.resposta5State = true
        }

        if (!this.captcha.form6.resposta6) {
          this.captcha.form6.resposta6State = false
          result = false
        } else {
          this.captcha.form6.resposta6State = true
        }

        if (!this.captcha.form6.foto1) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.foto2) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.foto3) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.foto4) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.foto5) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.foto6) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form6.correta) {
          this.captcha.form6.corretaState = false
          result = false
        } else {
          this.captcha.form6.corretaState = true
        }
      } else if (this.captcha.respostas === 9) {
        if (!this.captcha.form9.resposta1) {
          this.captcha.form9.resposta1State = false
          result = false
        } else {
          this.captcha.form9.resposta1State = true
        }

        if (!this.captcha.form9.resposta2) {
          this.captcha.form9.resposta2State = false
          result = false
        } else {
          this.captcha.form9.resposta2State = true
        }

        if (!this.captcha.form9.resposta3) {
          this.captcha.form9.resposta3State = false
          result = false
        } else {
          this.captcha.form9.resposta3State = true
        }

        if (!this.captcha.form9.resposta4) {
          this.captcha.form9.resposta4State = false
          result = false
        } else {
          this.captcha.form9.resposta4State = true
        }

        if (!this.captcha.form9.resposta5) {
          this.captcha.form9.resposta5State = false
          result = false
        } else {
          this.captcha.form9.resposta5State = true
        }

        if (!this.captcha.form9.resposta6) {
          this.captcha.form9.resposta6State = false
          result = false
        } else {
          this.captcha.form9.resposta6State = true
        }

        if (!this.captcha.form9.resposta7) {
          this.captcha.form9.resposta7State = false
          result = false
        } else {
          this.captcha.form9.resposta7State = true
        }

        if (!this.captcha.form9.resposta8) {
          this.captcha.form9.resposta8State = false
          result = false
        } else {
          this.captcha.form9.resposta8State = true
        }

        if (!this.captcha.form9.resposta9) {
          this.captcha.form9.resposta9State = false
          result = false
        } else {
          this.captcha.form9.resposta9State = true
        }

        if (!this.captcha.form9.foto1) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto2) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto3) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto4) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto5) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto6) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto7) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.foto8) {
          this.validacaoImagens = true
          result = false
          count = count + 1
        } else {
          this.validacaoImagens = false
          result = true
        }

        if (!this.captcha.form9.correta) {
          this.captcha.form9.corretaState = false
          result = false
        } else {
          this.captcha.form9.corretaState = true
        }

        if (!this.captcha.form9.correta) {
          this.captcha.form9.corretaState = false
          result = false
        } else {
          this.captcha.form9.corretaState = true
        }
      }

      if (count) {
        $(window).scrollTop(0)
        this.validacaoImagens = true
        return false
      }

      return result
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    }
  }
}
</script>

<style scoped>
    img.preview {
        width: 200px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/captchas/CadastrarCaptcha.vue